// Software built by  Adeweb Developer Africa
// portfolio website: https://adeweb-developer.vercel.app
// whatsApp Message: https://wa.me/23407043455416
// I am open for your software development gig, thank you 


import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./UserDetails.css";
import { useState } from "react";
import BackArrow from "../../assets/goBackarrow.svg";
import ChatAssistance from "../../assets/OnboardingCards/HelpLoverr.svg";
import {
  FaHeart,
  FaRegThumbsUp,
  FaStar,
  FaRegComment,
  FaTrash,
} from "react-icons/fa"; 
import {
  IoFootball,
  IoMusicalNotes,
  IoAirplane,
  IoLaptop,
  IoGameController,
} from "react-icons/io5";
import { FaPaintBrush } from "react-icons/fa";
import { MdOutlineCamera } from "react-icons/md";
import { FaShirt } from "react-icons/fa6";
import { PiCookingPotFill, PiHeartHalfDuotone } from "react-icons/pi";
import CameraLook from "../../assets/OnboardingCards/Camera-look.svg";
import LoveLike from "../../assets/UserdetailsIcons/Lovelike.svg";
import DislikeBTN from "../../assets/UserdetailsIcons/DislikeBTN.svg";
import SendAm from "../../assets/UserdetailsIcons/Sendmessage.svg";
import StarBtn from "../../assets/UserdetailsIcons/StarBtn.svg";
import LocaIcon from "../../assets/UserdetailsIcons/LocaIcon.svg";
import Loader from "../Loader/Loader";
import { auth, db } from "../../firebase";
import { doc, setDoc, addDoc, collection } from "firebase/firestore";


const UserDetails = () => {
  const location = useLocation();
  const { user } = location.state || {};
  const navigate = useNavigate();

  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState("");

  if (!user) {
    return <Loader />;
  }

  const getIconForInterest = (interest) => {
    // Mapping each interest to an icon
    switch (interest) {
      case "Sports":
        return <IoFootball size={25} />;
      case "Photography":
        return <MdOutlineCamera size={25} />;
      case "Travel":
        return <IoAirplane size={25} />;
      case "Technology":
        return <IoLaptop size={25} />;
      case "Music":
        return <IoMusicalNotes size={25} />;
      case "Cooking":
        return <PiCookingPotFill size={25} />;
      case "Art":
        return <FaPaintBrush size={25} />;
      case "Fashion":
        return <FaShirt size={25} />;
      case "Relationships":
        return <PiHeartHalfDuotone size={25} />;
      case "Gaming":
        return <IoGameController size={25} />;
      default:
        return null;
    }
  };

  const handleAction = async (actionType) => {
    const currentUser = auth.currentUser;
    if (currentUser) {
      const currentUserId = currentUser.uid;
      const swipedUserId = user.id;

      try {
        const currentUserDisplayName =
          currentUser.displayName || "Unknown User";
        const currentUserPhotoURL =
          currentUser.photoURL || "default-user-image-url";
        const [firstName = "Unknown", lastName = "User"] =
          currentUserDisplayName.split(" ");

        if (actionType === "like") {
          // Like
          await setDoc(
            doc(db, "users", currentUserId, "likes", swipedUserId),
            user
          );
          await addDoc(collection(db, "notifications"), {
            userId: swipedUserId,
            type: "like",
            message: `${firstName} liked you`,
            timestamp: new Date(),
            seen: false,
            avatar: currentUserPhotoURL,
          });
          triggerPopup("like");
        } else if (actionType === "dislike") {
          // Dislike
          await setDoc(
            doc(db, "users", currentUserId, "dislikes", swipedUserId),
            user
          );
          triggerPopup("dislike");
        } else if (actionType === "match") {
          // Match (assuming mutual like)
          await setDoc(
            doc(db, "users", currentUserId, "matches", swipedUserId),
            user
          );
          await setDoc(
            doc(db, "users", swipedUserId, "matches", currentUserId),
            {
              id: currentUserId,
              firstName,
              lastName,
              location: currentUser.location || "Unknown Location",
              photoURL: currentUserPhotoURL,
            }
          );
          await addDoc(collection(db, "notifications"), {
            userId: swipedUserId,
            type: "match",
            message: `You matched with ${firstName}`,
            timestamp: new Date(),
            seen: false,
            avatar: currentUserPhotoURL,
          });
          await addDoc(collection(db, "notifications"), {
            userId: currentUserId,
            type: "match",
            message: `${user.firstName} matched with you, wow!`,
            timestamp: new Date(),
            seen: false,
            avatar: user.profilePicture || "default-user-image-url",
          });
          triggerPopup("match");
        }
      } catch (error) {
        console.error("Error handling action:", error);
      }
    }
  };

  const triggerPopup = (type) => {
    setPopupType(type);
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), 2000); // Hide popup after 2 seconds
  };

  const renderPopup = () => {
    let message = "";
    if (popupType === "like") message = "You liked this user!";
    else if (popupType === "dislike") message = "You disliked this user!";
    else if (popupType === "match") message = "It's a match!";

    return (
      <div className={`popup ${showPopup ? "show" : ""}`}>
        {message}
      </div>
    );
  };
  

  return (
    <div className="userDetails">
      {renderPopup()}
      <div style={{ paddingTop: 16 }} className="onboardingBackBTN">
        <button onClick={() => navigate(-1)}>
          <img src={BackArrow} alt="back button" />
        </button>

        <button>
          <img src={ChatAssistance} alt="assistance" />
        </button>
      </div>

      <div
        style={{
          background: `url(${user.profilePicture})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top",
          backgroundSize: "cover",
        }}
        className="userdetailsBox"
      >
        <div className="userDetailsPicture">
          <img
            className="userDetailsPicturee"
            src={user.profilePicture}
            alt="User"
          />
        </div>
        <div className="usernfo">
          <div className="buttonHolder">
            <button onClick={() => handleAction("dislike")} className="actionButtonn">
              <img className="" src={DislikeBTN} alt="dislike" />
            </button>
            <button onClick={() => handleAction("match")} className="actionButtonn">
              <img className="" src={LoveLike} alt="like" />
            </button>
            <button onClick={() => handleAction("like")} className="actionButtonn">
              <img className="" src={StarBtn} alt="star" />
            </button>
          </div>
          <div className="messageUser">
            <div className="nameDetailsHolder">
              <div className="nameDetails">
                <h2>{user.firstName}</h2>
                <h2>{user.lastName}</h2>
              </div>
              {user.title || "No title yet"}
            </div>
            <button
              onClick={() => navigate(`/chat/${user.id}`)}
              className="sendall"
            >
              <img className="" src={SendAm} alt="send message" />
            </button>
          </div>
          <div className="fancyLocation">
            <div className="locationDetailsf">
              <div className="boldername">Location</div>
              {user.location}
            </div>
            <div className="locationandageicon">
              <p style={{ width: 60, backgroundColor: "#e91e6307" }}>
                <img style={{ width: 25 }} src={LocaIcon} alt="location icon" />
              </p>
              <p>
                age: <span style={{ fontSize: 30 }}>{user.age}</span>{" "}
              </p>
            </div>
          </div>
          <p>{user.gender}</p>

          <div className="aboutUser">
            <div className="boldernamee">About</div>
            <div className="aboutsection">
              {user.aboutMe || "This user hasn't written about themselves yet."}
            </div>
          </div>

          <div className="interestButtons">
            <div className="boldernamee">Interests</div>
            <div className="boldernameesmall">
              These are the interests you chose when signing up, we will show it
              to others.
            </div>
            {user.interests && user.interests.length > 0 ? (
              user.interests.map((interest, index) => (
                <button key={index} className="interestButton">
                  {getIconForInterest(interest) && (
                    <span className="interestIcon">
                      {getIconForInterest(interest)}
                    </span>
                  )}
                  {interest}
                </button>
              ))
            ) : (
              <p>No interests available</p>
            )}
          </div>

          <div className="userImages">
            <div className="boldernamee">User Gallery</div>
            <div className="boldernameesmall">
              Pictures are a way of showing who we are. This user has uploaded
              these additional pictures.
            </div>
            <div className="userdetailsEmailHolder">
              {user.additionalPictures && user.additionalPictures.length > 0 ? (
                user.additionalPictures.map((picture, index) => (
                  <img
                    key={index}
                    src={picture}
                    alt={`User pic ${index + 1}`}
                    className="additionalPicture"
                  />
                ))
              ) : (
                <div className="boldernameesmall">
                  This user doesn't have additional pictures. Please check back
                  later.
                </div>
              )}
            </div>

            <button
              onClick={() => navigate("/profile")}
              className="interestButton"
            >
              Visit your profile to add pictures
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
